import { useMemo } from "react";
import { isStatusRefetching } from "./states/statusFlags";
import type { DataGridStatus } from "./types";

/** `fromQuery` builds a new status object every render; key it on its fields. */
export const useStableStatus = (status: DataGridStatus): DataGridStatus => {
    const isRefetching = isStatusRefetching(status);
    const onRetry = status.state === "error" ? status.onRetry : undefined;
    const { state } = status;
    return useMemo((): DataGridStatus => {
        if (state === "error") {
            return { state, onRetry };
        }
        return state === "loading" ? { state } : { state, isRefetching };
    }, [state, isRefetching, onRetry]);
};
